// ============================================================
// BRIDGE — talks to the React Native WebView host, if there is one.
//
// This page also works standalone in a normal mobile/desktop
// browser (Option A) — window.ReactNativeWebView is simply
// undefined there, so every function below becomes a no-op.
// Nothing in this file assumes it's running inside a WebView.
//
// Message shape sent to RN: { type, ...payload }
// The RN-side WebView component listens via onMessage and should
// switch on `type`:
//   'leave'        — user pressed hang-up; RN should close/hide
//                    the WebView (navigation.goBack() or similar).
//   'auth-expired' — the idToken passed in the URL expired mid-call
//                    (call token endpoint returned 401). RN should
//                    fetch a fresh idToken and reload the WebView
//                    with an updated ?idToken=... — this page has
//                    no way to refresh its own Firebase session.
//   'ready'        — page mounted and bootstrap params were valid;
//                    RN can dismiss any loading spinner shown while
//                    the WebView itself was loading.
// ============================================================

const isInRNWebView = () => typeof window !== 'undefined' && !!window.ReactNativeWebView

export function postToNative(type, payload = {}) {
  if (!isInRNWebView()) {
    // Standalone browser mode — nothing to bridge to. Useful no-op
    // logging so Option A (plain browser tab) doesn't silently swallow events.
    if (type === 'leave') {
      console.log('[bridge] leave requested (standalone browser — no host to notify)')
    }
    return
  }
  try {
    window.ReactNativeWebView.postMessage(JSON.stringify({ type, ...payload }))
  } catch (err) {
    console.error('[bridge] postMessage failed', err)
  }
}

export const notifyReady       = () => postToNative('ready')
export const notifyLeave       = () => postToNative('leave')
export const notifyPeerLeft    = () => postToNative('peer-left')
export const notifyAuthExpired = () => postToNative('auth-expired')